webpackJsonp([12729642909824],{

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _centraliserDonnees = __webpack_require__(102);
	
	var _centraliserDonnees2 = _interopRequireDefault(_centraliserDonnees);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _audit = __webpack_require__(786);
	
	var _audit2 = _interopRequireDefault(_audit);
	
	var _quality = __webpack_require__(178);
	
	var _quality2 = _interopRequireDefault(_quality);
	
	var _RightPicture = __webpack_require__(33);
	
	var _RightPicture2 = _interopRequireDefault(_RightPicture);
	
	var _CheckModule = __webpack_require__(32);
	
	var _CheckModule2 = _interopRequireDefault(_CheckModule);
	
	var _ideas = __webpack_require__(795);
	
	var _ideas2 = _interopRequireDefault(_ideas);
	
	var _technologies = __webpack_require__(42);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _symfony = __webpack_require__(41);
	
	var _symfony2 = _interopRequireDefault(_symfony);
	
	var _nodejs = __webpack_require__(40);
	
	var _nodejs2 = _interopRequireDefault(_nodejs);
	
	var _angularReact = __webpack_require__(37);
	
	var _angularReact2 = _interopRequireDefault(_angularReact);
	
	var _baseDeDonnee = __webpack_require__(38);
	
	var _baseDeDonnee2 = _interopRequireDefault(_baseDeDonnee);
	
	var _goal = __webpack_require__(794);
	
	var _goal2 = _interopRequireDefault(_goal);
	
	var _htmlCssJs = __webpack_require__(39);
	
	var _htmlCssJs2 = _interopRequireDefault(_htmlCssJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Conseil = function (_Component) {
	  _inherits(Conseil, _Component);
	
	  function Conseil() {
	    _classCallCheck(this, Conseil);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Conseil.prototype.render = function render() {
	    var title = "Expert Symfony";
	    var goto = "En découvrir plus";
	    var alt = "test";
	    var description = ["Les équipes d'Integral Service sont composés d'experts dans leurs domaines. Avec ", _react2.default.createElement(
	      "strong",
	      null,
	      "plus de 10 ans d'exp\xE9rience en moyenne"
	    ), " nous vous accompagnons sur vos besoins en terme de conseil, Audit techniques, ou accompagnement.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Nous vous proposons également un ", _react2.default.createElement(
	      "a",
	      { href: "/startup", title: "Conseil pour startup" },
	      "service de CTO pour entreprise"
	    ), " afin de vous apporter un conseil fonctionnel et technique adapté à vos besoins."];
	    var smalltitle = "Projet et applications";
	    var titlemethodo = "Audit technique";
	    var descriptionmethodo = ["Nous proposons des prestations d'audit technique des applications, sites et API basées sur le framework Symfony.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Parce que pour nous, faire un audit nécessite une réelle expertise, nous ne proposons des audit que sur les technologies que nous maîtrisons.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Nous délivrons des rapports complets et documentés ainsi que, le cas échéants, un processus qualité pour résoudre les éventuels problèmes soulevés."];
	    var pictureMethodo = _audit2.default;
	    var altmethodo = "Méthodologie agile Scrum en image";
	
	    var smalltitleevol = "Un conseil avisé grâce à un large éventail d'expériences";
	    var titleevol = "Le conseil";
	    var descriptionevol = ["Nous proposons des prestations de conseils autour de vos besoins Web et de votre système d'information. Nous accompagnons plusieurs partenaires autour de conseils dans la ", _react2.default.createElement(
	      "strong",
	      null,
	      "strat\xE9gie du syst\xE8me d'information"
	    ), " ainsi que dans la ", _react2.default.createElement(
	      "strong",
	      null,
	      "digitalisation de processus m\xE9tiers"
	    ), ".", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Parce que toute activité est différente, nous adaptons nos processus et nos conseils en fonction de votre organisation et vos métiers."];
	
	    var altevol = "Intégration du portail dans votre système d'informations";
	
	    var smalltitleCheck = "Aide & conseil";
	    var titleCheck = "Accompagnement";
	    var subtitle1Check = "Un accompagnement quotidien";
	    var text1Check = ["Votre métier est notre priorité. Nous vous accompagnons pour vous aider dans votre stratégie digitale.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Nous vous écoutons donc pour vous aider au mieux dans l'avancement de la digitalisation de vos processus métiers en respectant votre stratéggie de Système d'information."];
	    var pictureCheck = _quality2.default;
	    var altCheck = "La communication";
	
	    return _react2.default.createElement(
	      "div",
	      { className: "generic-services" },
	      _react2.default.createElement(_MainPicture2.default, { title: "Une \xE9quipe d'experts", description: description, picture: _goal2.default, alt: alt }),
	      _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _ideas2.default, alt: altevol }),
	      _react2.default.createElement(_LeftPictureBackground2.default, { smalltitle: smalltitle, title: titlemethodo, description: descriptionmethodo, picture: pictureMethodo, alt: altmethodo }),
	      _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleCheck, title: titleCheck, description: text1Check, picture: pictureCheck, alt: altCheck })
	    );
	  };
	
	  return Conseil;
	}(_react.Component);
	
	exports.default = Conseil;
	module.exports = exports["default"];

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/audit.926617ac.png";

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/centraliser-donnees.14425800.png";

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/goal.1e21076c.png";

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ideas.4ada6e45.png";

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quality.3ab2b4ce.png";

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Conseil = __webpack_require__(288);
	
	var _Conseil2 = _interopRequireDefault(_Conseil);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _innovationApplicationWeb = __webpack_require__(180);
	
	var _innovationApplicationWeb2 = _interopRequireDefault(_innovationApplicationWeb);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConseilApp = function (_Component) {
	    _inherits(ConseilApp, _Component);
	
	    function ConseilApp() {
	        _classCallCheck(this, ConseilApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ConseilApp.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Conseil, Audit & accompagnement",
	                "description": "Notre Agence Web vous propose de vous accompagner dans tous vos projets Web et Mobile à l'aide de services complémentaires, réalisés par des experts !",
	                "cover": _innovationApplicationWeb2.default
	            }
	        };
	
	        var title = "Conseil, Audit & accompagnement";
	        var description = "Notre expertise à votre service";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Conseil, Audit & accompagnement | " + _SiteConfig2.default.siteTitle,
	                description: "Notre Agence Web vous propose de vous accompagner dans tous vos projets Web et Mobile \xE0 l'aide de services compl\xE9mentaires, r\xE9alis\xE9s par des experts !"
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _innovationApplicationWeb2.default }),
	            _react2.default.createElement(_Conseil2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return ConseilApp;
	}(_react.Component);
	
	exports.default = ConseilApp;
	
	;
	module.exports = exports["default"];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/innovation-application-web.e6d34b48.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-conseil-jsx-62a2ac32fab1c2ea1389.js